import React, { useMemo } from 'react';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ChecklistIcon from '@mui/icons-material/Checklist';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import ChatIcon from '@mui/icons-material/Chat';
import PersonIcon from '@mui/icons-material/Person';
import { useLocation, useNavigate } from 'react-router-dom';
import { usePermissions } from '../context/PermissionsContext';

const NAV_ITEMS = [
  { value: '/dashboard', label: 'Dashboard', icon: DashboardIcon, module: 'dashboard' },
  { value: '/tasks', label: 'Pendientes', icon: ChecklistIcon, module: 'tasks' },
  { value: '/projects', label: 'Projects', icon: BusinessCenterIcon, module: 'projects' },
  { value: '/chat', label: 'Chat', icon: ChatIcon, module: 'chat' },
  { value: '/profile', label: 'Profile', icon: PersonIcon, module: null }
];

const resolveNavValue = (pathname, availableItems) => {
  if (!pathname) return availableItems[0]?.value || '/dashboard';
  const matched = availableItems.find((item) => pathname === item.value || pathname.startsWith(`${item.value}/`));
  return matched?.value || availableItems[0]?.value || '/dashboard';
};

export default function MobileBottomNav() {
  const { hasPermission } = usePermissions();
  const location = useLocation();
  const navigate = useNavigate();

  const availableItems = useMemo(
    () => NAV_ITEMS.filter((item) => !item.module || hasPermission(item.module, 'view')),
    [hasPermission]
  );

  const navValue = resolveNavValue(location.pathname, availableItems);

  if (!availableItems.length) return null;

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.appBar + 2,
        borderTop: '1px solid',
        borderColor: 'divider',
        display: { xs: 'block', md: 'none' },
        pb: 'env(safe-area-inset-bottom, 0px)',
        pl: 'env(safe-area-inset-left, 0px)',
        pr: 'env(safe-area-inset-right, 0px)'
      }}
    >
      <BottomNavigation
        showLabels
        value={navValue}
        onChange={(_, nextValue) => {
          if (nextValue && nextValue !== location.pathname) navigate(nextValue);
        }}
        sx={{
          height: 64,
          bgcolor: 'background.paper',
          '& .MuiBottomNavigationAction-root': {
            minWidth: 0,
            px: 0.25
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.68rem'
          }
        }}
      >
        {availableItems.map((item) => {
          const Icon = item.icon;
          return (
            <BottomNavigationAction
              key={item.value}
              value={item.value}
              label={item.label}
              icon={<Icon fontSize="small" />}
            />
          );
        })}
      </BottomNavigation>
    </Paper>
  );
}
